// Strip Markdown code fences / leaked JSON from a WEVA narrative so cards and
// detail views never show raw ```json {...``` blobs. Mirrors the mobile helper.
export function cleanNarrative(raw) {
  if (!raw) return "";
  let s = String(raw).trim();
  s = s.replace(/^```[a-zA-Z0-9]*\s*\n?/g, "");
  s = s.replace(/```$/g, "").trim();
  if (s.startsWith("{")) {
    try {
      const j = JSON.parse(s);
      const nested = j?.narrative || j?.text || j?.summary ||
        (typeof j?.overview === "string" ? j.overview : null) ||
        (typeof j?.content === "string" ? j.content : null);
      if (nested && typeof nested === "string") return nested.trim();
    } catch { /* fall through */ }
    s = s.replace(/^\{/, "").replace(/\}\s*$/, "").trim();
  }
  return s;
}

export const PILLAR_COLOR = { realize: "#5E7A73", designate: "#7A6A5E", release: "#8A6B7A" };

export function pillarLabel(p) {
  return (p || "").toUpperCase();
}
